import 'css-chunk:src/app/containers/Home/ClientFeaturesView/ClientFeatureList.scss';export default {
  "ClientFeatureList": "_ClientFeatureList_t01cs_2",
  "header": "_header_t01cs_2",
  "createButton": "_createButton_t01cs_7",
  "bulkApplyButton": "_bulkApplyButton_t01cs_10",
  "table": "_table_t01cs_13",
  "nameCell": "_nameCell_t01cs_13"
};